import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ListItem } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { useNavItemStyles } from "./styles";
export const NavItem = ({ route: { path, title, icon: Icon }, }) => {
    const classes = useNavItemStyles();
    return (_jsx(ListItem, Object.assign({ className: classes.item, disableGutters: true }, { children: _jsxs(Button, Object.assign({ activeClassName: classes.active, className: classes.button, component: NavLink, to: path }, { children: [Icon && _jsx(Icon, { className: classes.icon }, void 0),
                _jsx("span", Object.assign({ className: classes.title }, { children: title }), void 0)] }), void 0) }), void 0));
};
//# sourceMappingURL=NavItem.js.map